// extracted by mini-css-extract-plugin
export default {"container":"style_container__RPSyY","exBox":"style_exBox__T7gdY","tableDetail":"style_tableDetail__setqA","dimentions":"style_dimentions__lnhuR"};